import { Form, FormGroup, FormParagraph } from '@ksyos/design-system';
import type { ServiceCode } from '@common/enums';
import { getSelectedLanguage } from '@frontend/translate';
import type { IDevice } from './DeviceDetails';

type DeviceInformationCardReadBody = {
    device: IDevice;
    serviceCodes: ServiceCode[];
};

export function DeviceInformationCardReadBody(props: Readonly<DeviceInformationCardReadBody>) {
    const translate = getSelectedLanguage();

    const { device, serviceCodes } = props;

    const entries = [
        {
            label: translate.devices.type,
            value: device.deviceType?.name,
        },
        {
            label: translate.deviceTypes.model,
            value: device.deviceType?.model,
        },
        {
            label: translate.deviceTypes.version,
            value: device.deviceType?.version,
        },
        {
            label: translate.devices.serialNumber,
            value: device.externalId,
        },
        {
            label: serviceCodes.length > 1 ? translate.service.services : translate.service.service,
            value: serviceCodes.join(', '),
        },
        ...(device.notes
            ? [
                  {
                      label: translate.devices.notes,
                      value: device.notes,
                  },
              ]
            : []),
    ];

    return (
        <Form submitOnEnter={false}>
            {entries.map((entry) => (
                <FormGroup
                    key={entry.label}
                    label={entry.label}
                >
                    <FormParagraph>{entry.value ?? '-'}</FormParagraph>
                </FormGroup>
            ))}
        </Form>
    );
}
